export const PLATE_BRAND_IMAGE = "/images/brand/plate-icon-white-v1-512.png";
